import React from 'react';
import PropTypes from 'prop-types';
import Typography from '@mui/material/Typography';
import CardHeader from '../../headers/CardHeader';
import CardFooter from '../../footers/CardFooter';
import KeyValueStack from '../../stacks/KeyValueStack';
import ConditionalBorderStack from '../../stacks/ConditionalBorderStack';

const DesktopCredentialsCard = ({
  id,
  title,
  subtitle,
  isOk,
  credentials,
  errorMessage,
  toggle,
  disabled,
}) => (
  <ConditionalBorderStack id={id} showBorder={false} onConditionalClick={toggle} minHeight={150}>
    <CardHeader status={isOk} primaryText={title} />
    <Typography px={3} mb={1}>
      {subtitle}
    </Typography>
    <CardFooter
      id={id}
      errorMessage={errorMessage}
      success={isOk}
      onActionClick={() => {}}
      disabled={disabled}
    >
      <KeyValueStack items={credentials} />
    </CardFooter>
  </ConditionalBorderStack>
);

DesktopCredentialsCard.propTypes = {
  id: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  isOk: PropTypes.bool.isRequired,
  credentials: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      value: PropTypes.string,
    }),
  ),
  errorMessage: PropTypes.string.isRequired,
  toggle: PropTypes.func,
  disabled: PropTypes.bool,
};

DesktopCredentialsCard.defaultProps = {
  credentials: [],
  subtitle: '',
  toggle: null,
  disabled: false,
};

export default DesktopCredentialsCard;
